import React from 'react';

interface JsonMessagesProps {
    jsonMsgHistory: any[]; // Replace 'any' with the correct type for your JSON messages
}

const JsonMessages: React.FC<JsonMessagesProps> = ({ jsonMsgHistory }) => {
    return (
        <div className='json-part'>
            {jsonMsgHistory.map((message: any, idx: any) => (
                <li key={idx}>
                    <pre> {JSON.stringify(message, null, 2)}</pre>
                </li>
            ))}
        </div>
    );
};

export default JsonMessages;
